import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { usePrefersReducedMotion } from '@hooks';

const StyledBackToTop = styled.button`
  ${({ theme }) => theme.mixins.flexCenter};
  position: fixed;
  right: 20px;
  bottom: 24px;
  width: 46px;
  height: 46px;
  border: 1px solid var(--green);
  border-radius: 999px;
  background-color: rgba(10, 25, 47, 0.9);
  color: var(--green);
  box-shadow: 0 10px 30px -15px var(--navy-shadow);
  z-index: 12;
  transition: var(--transition);
  opacity: 0;
  pointer-events: none;
  transform: translateY(10px);

  svg {
    width: 20px;
    height: 20px;
  }

  &:hover,
  &:focus-visible {
    outline: none;
    transform: translateY(-2px);
    box-shadow: 0 15px 30px -15px var(--navy-shadow);
    background-color: var(--light-navy);
  }

  ${props =>
    props.$visible &&
    css`
      opacity: 1;
      pointer-events: auto;
      transform: translateY(0);
    `}

  @media (min-width: 769px) {
    right: 92px;
    bottom: 30px;
  }
`;

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const updateVisibility = () => {
      setIsVisible(window.pageYOffset > 500);
    };

    updateVisibility();
    window.addEventListener('scroll', updateVisibility, { passive: true });

    return () => window.removeEventListener('scroll', updateVisibility);
  }, []);

  const scrollToTop = () => {
    if (typeof window === 'undefined') {
      return;
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
    });
  };

  return (
    <StyledBackToTop
      type="button"
      onClick={scrollToTop}
      aria-label="Back to top"
      title="Back to top"
      $visible={isVisible}>
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          d="M12 3.5l6.5 6.5-1.4 1.4-4.1-4.1V20.5h-2V7.3l-4.1 4.1-1.4-1.4L12 3.5z"
          fill="currentColor"
        />
      </svg>
    </StyledBackToTop>
  );
};

export default BackToTop;
